import React from "react";

const InvalidAccessView = () => (
  <div className="zero-items">
    <h2 className="text-danger">
      {" "}Sorry you don't have access to this view!!!{" "}
    </h2>
  </div>
);

export default InvalidAccessView;



// WEBPACK FOOTER //
// ./src/components/InvalidAccessView.js